export default __webpack_public_path__ + "static/1304-c42483c0ee8f4a1e563ee945bb7b2646.gif";